import React, { useState } from 'react'
import styled from 'styled-components'

const SPopoverContent = styled.div`
  position: absolute;
  left: 50%;
  top: -70px;
  transform: translate(-50%);
  width: 219px;
  padding: 14px 15px 14px 15px;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  color: #AC562B;
  font-weight: normal;
  border-radius: 7px;
  background-color:#FFF3E0;
  box-sizing: border-box;
  box-shadow: 0px 2px 16px rgba(171, 133, 115, 0.43);
  font-family: 'Inter var',sans-serif;
`;

const SPopoverIcon = styled.div`
  position: relative;
  left: 10px;
  display: inline-block;
  width: 12px;
  height: 12px;
  line-height: 12px;
  font-size: 12px;
  color: #AC562A;
  border-radius: 50%;
  background-color:#FFFDFA;
  cursor:pointer;
  flex-shrink: 0;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    left: 5px;
  `}
`;

const SPopoverArrow = styled.div`
    position: absolute;
    height: 8px;
    width: 8px;
    left: 50%;
    bottom: -7px;
    margin-left: -2px;
    background: #FFF3E0;
    transform: rotate(45deg) translate(-50%);
`;

const SPopoverEventBar = styled.div`
  position: absolute;
  bottom: -12px;
  left: 0;
  height: 12px;
  width: 100%;
  background-color: transparent;
`;

interface PopoverProps {
  disabled?: boolean
  children: never[]
  tokeName: string
}

export default function Popover({disabled = false, tokeName = ''}: PopoverProps) {
  const [visible, setVisible] = useState(false)
  const onShowPopover = () => {
    if (disabled) return;
    if(!visible) setVisible(true)
  }
  const onHidePopover = ()=>{
    if (disabled) return;
    if(visible) setVisible(false)
  }
  const event = {
    onMouseEnter: onShowPopover,
    onMouseOver: onShowPopover,
    onMouseOut: onHidePopover
  }
  return (
    <>
      <SPopoverIcon {...event}>
        ?
        <SPopoverContent style={{'display': visible ? 'block' : 'none'}}>
          The insufficient part of {tokeName.toLocaleUpperCase()} will be converted into equivalent {tokeName.toLocaleUpperCase()}
          <SPopoverArrow/>
          <SPopoverEventBar/>
        </SPopoverContent>
      </SPopoverIcon>
    </>
  );
};